// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/compliance/modals/shared/ModalShell.jsx

import React from "react";
import { Modal } from "../../../../design-system/components";

export default function ModalShell({
  open = true,
  ariaLabel,
  eyebrow,
  title,
  subtitle,
  onClose,
  children,
  maxWidth = "1180px",
  accentBorder = "rgba(52, 211, 153, 0.45)",
  zIndex = 140,
  className = "",
  overlayClassName = "",
  headerClassName = "",
  bodyClassName = "",
}) {
  return (
    <Modal
      open={open}
      ariaLabel={ariaLabel || title || "OASYS modal"}
      eyebrow={eyebrow}
      title={title}
      description={subtitle}
      onClose={onClose}
      closeOnBackdrop={Boolean(onClose)}
      closeOnEscape={Boolean(onClose)}
      maxWidth={maxWidth}
      accentBorder={accentBorder}
      zIndex={zIndex}
      theme="inherit"
      className={className}
      overlayClassName={overlayClassName}
      headerClassName={headerClassName}
      bodyClassName={bodyClassName}
    >
      {children}
    </Modal>
  );
}
